import React, { useMemo } from 'react';
import { DbComponentItemType, ComponentInfoType, DbCompontentGroupInfoType } from '@/pages/dashboard/types/dashboard';
import { FILTER_TYPE_COMMON, FILTER_TYPE_SEFL } from '@/pages/dashboard/_config/constant';
import ComponentsMap from '@/pages/dashboard/_config/compontents';
import DbComponentGroup from '@/pages/dashboard/components/DbComponent/DbCompontentGroup';
interface DbComponentProps {
  list: DbComponentItemType[]; // 组件列表
  gameCode: string;
  timeZone: string | undefined;
}

const DbComponent =  (props: DbComponentProps) => {
  const { list = [], gameCode, timeZone } = props;
  // 组件列表，按筛选器做分组处理，相同的筛选器集中到同一组
  const listInfo: DbCompontentGroupInfoType[]  = useMemo(() => {
    let groupList: DbCompontentGroupInfoType[] = [];
    list.forEach((item) => {
      const { name, filterType = FILTER_TYPE_COMMON } = item;
      // 获取组件的具体信息，包含筛选器
      // @ts-ignore
      const componentInfo: ComponentInfoType = ComponentsMap[name];
      if (filterType === FILTER_TYPE_COMMON) {
        // 查询分组中是否有该筛选器的信息
        const idx = groupList.findIndex((item) => {
          return (item.type = FILTER_TYPE_COMMON) && (item.group === componentInfo.filter);
        });
        // 插入组件到分组列表中
        if (idx > -1) {
          groupList[idx].components.push(item);
        } else {
          groupList.push({
            group: componentInfo.filter,
            type: FILTER_TYPE_COMMON,
            components: [item]
          });
        }
      } else {
        groupList.push({
          group: componentInfo.filter,
          type: FILTER_TYPE_SEFL,
          components: [item]
        });
      }
    });
    return groupList;
  }, [list]);
  return (
    <>
      {listInfo.map((item, index) => {
        return <DbComponentGroup gameCode={gameCode} timeZone={timeZone} info={item} key={item.group + item.type + JSON.stringify(item.components) + index} />
      })}
    </>
  );
}

export default DbComponent;
